import { X } from "lucide-react";
import React from "react";

import { cn } from "@/common/utils/utils";

interface CloseButtonProps {
  onClick?: () => void;
  className?: string;
  size?: number;
  disabled?: boolean;
  "aria-label"?: string;
}

const CloseButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(
  (
    {
      onClick,
      className,
      size = 16,
      disabled = false,
      "aria-label": ariaLabel = "Close",
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel}
        className={cn(
          "inline-flex h-7 w-7 items-center justify-center rounded-md",
          "text-gray-500 hover:text-gray-900 hover:bg-gray-100",
          "transition-colors cursor-pointer",
          "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
          "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
      >
        <X size={size} />
      </button>
    );
  },
);

CloseButton.displayName = "CloseButton";

export default CloseButton;
